import Vue from 'vue';
import i18n from "@/i18n" //根据项目对应真实路径
const state = {
  lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en', //en、zh、ja
  screen: localStorage.getItem('screen') ? localStorage.getItem('screen') : 'pc', //pc、h5
  platform: sessionStorage.getItem('platform') ? sessionStorage.getItem('platform') : ''
}

const getters = {
  GET_LANG() {
    return state.lang;
  },
  GET_LANG2() {
    switch (state.lang) {
      case "zh":
        return "cn";
      case "en":
        return "en";
      case "ja":
        return "jp";
    }
  },
  GET_SCREEN() {
    return state.screen;
  },
  GET_PLATFORM() {
    return state.platform;
  }
}

const mutations = {
  SET_LANG(state, lang) { //写入选择的语言
    //console.log(lang)
    localStorage.setItem('lang', lang);
    state.lang = lang;
    i18n.locale = lang;
    window.scrollTo(0, 0)
  },
  SET_SCREEN(state, screen) { //写入当前是什么模式
    localStorage.setItem('screen', screen);
    state.screen = screen;
  },
  SET_PLATFORM(state, platform) { //写入当前是什么平台
    sessionStorage.setItem('platform', platform)
    state.platform = platform;
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js